import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20cloud%20textures%20in%20golden%20amber%20and%20cream%20tones%2C%20ethereal%20atmosphere%2C%20minimalist%20luxury%20aesthetic%2C%20dreamy%20soft%20light%20rays%2C%20high%20end%20corporate%20design%2C%20subtle%20geometric%20patterns&width=1800&height=900&seq=kaiyun-hero-bg&orientation=landscape"
          alt="开云平台背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <i className="ri-sparkling-line text-white text-sm"></i>
          <span className="text-white/90 text-sm font-medium">全新改版，开启无限可能</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
          探索
          <span className="text-primary-400"> 开云 </span>
          的无限可能
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          开云是您值得信赖的首选平台，汇聚核心优势与全方位服务体验。
          助您快速了解并上手开云，开启全新体验之旅。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate('/categories')}
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即体验
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
          <button
            onClick={() => navigate('/about')}
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold text-sm hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </button>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg mx-auto">
          {[
            { value: '50万+', label: '活跃用户' },
            { value: '200+', label: '合作企业' },
            { value: '99.9%', label: '服务可用率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
              <div className="text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}